import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestResetCode, resetPassword } from '../../api';
import Button from '../basic/MyButton';
import TextInput from '../basic/MyTextInput';

function PasswordReset() {
    const [step, setStep] = useState(1);
    const [identifier, setIdentifier] = useState('');
    const [resetCode, setResetCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [passwordsMatch, setPasswordsMatch] = useState(true);
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'identifier':
                setIdentifier(value);
                break;
            case 'resetCode':
                setResetCode(value);
                break;
            case 'newPassword':
                setNewPassword(value);
                setPasswordsMatch(value === confirmPassword);
                break;
            case 'confirmPassword':
                setConfirmPassword(value);
                setPasswordsMatch(newPassword === value);
                break;
            default:
                break;
        }
    };

    const handleRequestReset = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!identifier) {
            setError('Please enter your username or email.');
            return;
        }

        try {
            const response = await requestResetCode(identifier);
            setSuccess(`Reset code: ${response.resetCode}`);
            setStep(2);
        } catch (error) {
            setError(error.message || 'Failed to generate reset code. Please try again.');
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!resetCode || !newPassword || !confirmPassword) {
            setError('Please fill in all fields.');
            return;
        }
        if (!passwordsMatch) {
            setError('Passwords do not match.');
            return;
        }

        try {
            await resetPassword(identifier, newPassword, resetCode);
            setSuccess('Password reset successfully. You can now log in with your new password.');
            setTimeout(() => navigate('/auth/login'), 3000); // Redirect to login page after 3 seconds
        } catch (error) {
            setError(error.message || 'Failed to reset password. Please try again.');
        }
    };

    const canResetPassword = () => {
        return resetCode && newPassword && confirmPassword && passwordsMatch;
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f2f5' }}>
            <form onSubmit={step === 1 ? handleRequestReset : handleResetPassword} style={{ display: 'flex', flexDirection: 'column', width: '300px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', padding: '20px', borderRadius: '8px', backgroundColor: 'white' }}>
                <h2 style={{ textAlign: 'center' }}>Reset Password</h2>
                {step === 1 ? (
                    <>
                        <TextInput
                            label="Username or Email:"
                            name="identifier"
                            type="text"
                            value={identifier}
                            onChange={handleInputChange}
                            placeholder="Enter your username or email"
                        />
                        <Button
                            text="Request Reset Code"
                            type="submit"
                            color="white"
                            backgroundColor="#007AFF"
                            hoverBackgroundColor="#0056b3"
                            hoverColor="white"
                        />
                    </>
                ) : (
                    <>
                        <TextInput
                            label="Reset Code:"
                            name="resetCode"
                            type="text"
                            value={resetCode}
                            onChange={handleInputChange}
                            placeholder="Enter the reset code"
                        />
                        <TextInput
                            label="New Password:"
                            name="newPassword"
                            type="password"
                            value={newPassword}
                            onChange={handleInputChange}
                            placeholder="Enter your new password"
                        />
                        <TextInput
                            label="Confirm New Password:"
                            name="confirmPassword"
                            type="password"
                            value={confirmPassword}
                            onChange={handleInputChange}
                            placeholder="Confirm your new password"
                        />
                        {!passwordsMatch && newPassword && confirmPassword && (
                            <div style={{ color: 'red', textAlign: 'center' }}>Passwords do not match</div>
                        )}
                        <Button
                            text="Reset Password"
                            type="submit"
                            color="white"
                            backgroundColor="#007AFF"
                            hoverBackgroundColor="#0056b3"
                            hoverColor="white"
                            disabled={!canResetPassword()}
                        />
                    </>
                )}
                {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
                {success && <p style={{ color: 'green', textAlign: 'center' }}>{success}</p>}
            </form>
        </div>
    );
}

export default PasswordReset;